export default [
    'Party',
    'Events',
    'Abstract',
    'Tech',
    'Workspace',
    'Clothing',
    'City',
    'Landscapes',
    'Nature',
    'Food',
    'Beverages',
    'Spaces',
];
